import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { FEEDBACK_BUTTON_ID, COMPONENT_NAME } from "./constants.js";
function FeedbackLink(props) {
  var _a, _b, _c, _d;
  if (!props.entry) return null;
  const entry = props.entry;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          identifier: "footer",
          trackedData: [
            (_b = (_a = entry == null ? void 0 : entry.active_state) == null ? void 0 : _a.active_state_link) == null ? void 0 : _b.title
          ],
          type: "ui"
        },
        trackType: "navigation"
      },
      children: /* @__PURE__ */ jsx(
        Button,
        {
          "data-testid": COMPONENT_NAME,
          id: FEEDBACK_BUTTON_ID,
          uniqueId: "feedback",
          variant: "text-button",
          children: (_d = (_c = entry == null ? void 0 : entry.active_state) == null ? void 0 : _c.active_state_link) == null ? void 0 : _d.title
        }
      )
    }
  );
}
export {
  FeedbackLink
};
